<abs-modals-and-alerts-component [(modalAction)]="openModal" (modalClosed)="close($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component id="customer-cancel-modal-popup">
    <main class="modal-header" tabindex="0">
      <h1 style="display:none;"></h1>
      <h2 id="customer-cancel-modal-container">{{cfetLabels.utf_profile_cancel_modal.utf_heading}}</h2>
      <div class="corner-button">
        <button type="button" id="close-btn" class="close-modal-button" tabindex="0" [attr.aria-label]="'Close'"
          (click)="close($event, 'openModal')" (keyup)="close($event,'openModal')">
          <em aria-label="Close" id="icon-close" class="icon-close modal-close-icon" role="img"></em>
        </button>
      </div>
    </main>
    <section class="modal-body" id="confirmation-buttons-section" modal-content tabindex="0">
      <p id="description" [innerHTML]='cfetLabels.utf_profile_cancel_modal.utf_description'></p>
      <div class="row no-gutters" id="confirmation-buttons">
        <button type="button" id="btn-cancel" (click)="cancelApplication($event,'openModal')"
          (keyup)="cancelApplication($event,'openModal')" class="btn btn-alt btn-medium" tabindex="0"><em
            aria-label=""></em>
          {{cfetButtonLabels.button_labels.utf_cancel_application}}</button>
        <div class="col-md-6">
          <button type="button" id="btn-stay" (click)="close($event,'openModal')" (keyup)="close($event,'openModal')"
            class="btn btn-alt btn-medium" tabindex="0"><em aria-label=""></em>
            {{cfetButtonLabels.button_labels.stay}}</button>
        </div>
      </div>
    </section>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>